module.exports = __webpack_public_path__ + "img/hospitality-tourism-and-retail-careers.8bbaf04f.jpg";